import { SharedError } from './errors';

/**
 * Ethiopian mobile numbers. Accepted inputs (spaces, dashes, dots and parentheses ignored):
 *   09XXXXXXXX, 07XXXXXXXX, 9XXXXXXXX, 7XXXXXXXX,
 *   2519XXXXXXXX, +2519XXXXXXXX, 002519XXXXXXXX (and the same with 7)
 * Output is E.164: +2519XXXXXXXX or +2517XXXXXXXX.
 */
const SEPARATORS = /[\s\-.()]/g;
const ETH_MOBILE = /^(?:\+251|00251|251|0)?([79]\d{8})$/;
export const E164_ETH_MOBILE = /^\+251[79]\d{8}$/;

export function normalizeEthiopianPhone(input: string): string {
  if (typeof input !== 'string') {
    throw new SharedError('INVALID_PHONE', 'Phone number must be a string');
  }
  const cleaned = input.replace(SEPARATORS, '');
  const match = ETH_MOBILE.exec(cleaned);
  if (!match) {
    throw new SharedError('INVALID_PHONE', 'Invalid Ethiopian mobile number');
  }
  return `+251${match[1] as string}`;
}

export function isValidEthiopianPhone(input: string): boolean {
  try {
    normalizeEthiopianPhone(input);
    return true;
  } catch {
    return false;
  }
}

/** "+251911223344" -> "+251 91 122 3344" for display. Input must already be E.164. */
export function formatEthiopianPhone(e164: string): string {
  if (!E164_ETH_MOBILE.test(e164)) {
    throw new SharedError('INVALID_PHONE', 'Expected an E.164 Ethiopian mobile number');
  }
  return `+251 ${e164.slice(4, 6)} ${e164.slice(6, 9)} ${e164.slice(9)}`;
}

/** "+251911223344" -> "+251 91 *** 3344" (for admin lists and logs). */
export function maskEthiopianPhone(e164: string): string {
  if (!E164_ETH_MOBILE.test(e164)) {
    throw new SharedError('INVALID_PHONE', 'Expected an E.164 Ethiopian mobile number');
  }
  return `+251 ${e164.slice(4, 6)} *** ${e164.slice(9)}`;
}
